export const ENTITY_RENDER_ORDER = {
  floor: 0,
  region: 10,
  floorPlan: 20,

  wall: 30,
  wallOutline: 31,

  floorOutline: 40,

  separateWallBg: 50,
  separateWall: 51,
  separateWallOutline: 52,

  column: 60,
  columnOutline: 61,

  doorWindowBg: 70,
  doorWindowBgOutline: 71,
  doorWindowOther: 72,
  doorWindowFan: 73,
  doorWindowFanOutline: 74,

  furniture: 80,
  furnitureOutline: 81,
  furnitureWorkPoint: 82,

  filledCircle: 90,
  hollowCircle: 92,

  orthogonalLine: 100,
  wallAbsorbPoint: 101,
  highlightedLine: 102, // 后面会删
  virtualWall: 103,
  virturalArcWall: 103,
  ruler: 104,
  dimension: 104,
  floorPlanDXF: 109,

  selectedOutline: 110,
  hoverOutline: 114, // 新增一个hover边框的renderOrder，防止多选时被box遮盖hover效果
  renderOrderTemp: 120,
  wallExtremePoint: 121,
  textInfo: 125,
  transformHelper: 130,
  rectangleHelper: 150,
  arrayPreviewHelper: 151,

  subline: 140 // 辅助定位线
} as const;

/**
 * 图层只用来把装饰性几何体从 2D 拾取里排除掉，不影响渲染：2D 相机是 layers.enableAll()，
 * 而拾取用的 Raycaster 只测 layer 0（见 controller2d/operateEntityController/rayIntersect），
 * 所以设了下面任一图层的对象就不会被射线命中。
 *
 * 只有「挂在 intersectableGroup 下、自身带几何体」的对象设图层才有意义：
 * three 在 layers.test 失败时仍会递归子节点，设在 Group 上不会传给子节点；
 * 挂在 scene 下的对象本来就不参与拾取，设了等于没设。
 */
export const ENTITY_LATER = {
  HELPER_LAYER: 4,
  TRANSFORM_LAYER: 5,
  HIGHLIGHT_LAYER: 6,
  WORK_POINT_LAYER: 7,
  MASK_PLANE_LAYER: 8
};

export const ENTITY_PRIORITY = {
  room: 1,
  region: 2,
  wall: 10,
  column: 30,
  separateWall: 40,

  doorWindow: 60,
  furniture: 70,
  modelGroup: 71,
  assembly: 72,
  linearDimension: 80,
  wallExtremePoint: 100,
  textInfo: 105,
  transformHelper: 110
};

export const ENTITY_PRIORITY_3D = {
  floor: 1,
  wall: 1,
  column: 1,
  doorWindow: 1,
  wallExtremePoint: 1,
  ceil: 1
};

export const ENTITY_3D_RENDER_ORDER = {
  entity: 0,
  columnFace: 0,
  wallFace: 0,
  regionFace: 0,
  glassFace: 10,
  boundingBox: 100
};

export const DEFAULT_WINDOW_OFFGROUND = 1220;

export const DEFAULT_DOOR_OFFGROUND = 0;

export const floor2dColor = 0xfff9eb;
export const floor2dDisabledColor = 0xf0f2f4;
export const transformWheelColor = 0x1a7af8;
export const errorHighlightedColor = 0xd40000;
export const virtual2dWallColor = 0x4c9dff;
export const wall2dColor = 0xb6b7bb;
export const hoverWall2dColor = 0xb6b7bb;
export const selectedWall2dColor = 0x77a7f6;
export const hellowCircleColor = 0x262829;
export const filledCircleColor = 0xffffff;
export const drawPointColor = 0x1cdc87;
export const adsorbWallLineColor = 0x1cdc87;
export const defaultOutlineColor = 0x262829;
export const column2dColor = 0x414140;
export const columnSelected2dColor = 0x77a7f6;
export const doorBgOutlineColor = 0xd2d3d7;
export const separateWallBGColor = 0xe6e7e9;
export const separateWallOutline = 0x818284;
export const selectedSeparateWallBGColor = 0xb1cfff;
export const virtualSeparateWallLineColor = 0x262829;
export const region2dColor = 0x00ff00;

export const selectedOutlineColor = 0x4c9dff;
export const hoverOutlineColor = 0x00e1ff;

export const windowBgColor = 0xffffff;

export const workPointColor = 0xd40000;

export const groundGridColor = 0xe6e7e9;

export const alignReferenceLineColor = 0xdf4545;

export enum DefaultEntitySize {
  WallExtremePointRadius = 100,
  WallExtremePointThickness = 10
}

export const AdsorbEntitySize = {
  PointRadius: 140,
  TriangleHeight: 280,
  SquareSize: 280,
  CrossLength: 280,
  Thickness: 30
} as const;

export enum WallLimit {
  MinLength = 200,
  MaxLength = 1e8 - 1
}

export const MULTI_SELECT_TEMPORARY_ID = 'multiSelectTemporary';
